export const MuiAutocomplete = {
  styleOverrides: {
    popupIndicator: {
      color: '#a8aeb8',
    },
  },
};
